export default __webpack_public_path__ + "static/media/desafio.b22dac01.png";